import { greaterThanOrEqualTo } from 'ngrx-forms/validation';
import { BuildValidatorWithComparandDecorator } from './helpers';

export const GreaterThanOrEqualTo = BuildValidatorWithComparandDecorator<
  number
>(greaterThanOrEqualTo, 'DX.FORMS.VALIDATION.ERRORS.GREATER_THEN_OR_EQUAL_TO');
